export const normalizeLocale = locale => locale.replace(/_/g, '-');